import { Box, Button, Grid, Typography } from "@mui/material";
import ABCLogo from "../../assets/images/ABC-Service.jpg";
import MobileNumberEntry from "./MobileNumberEntry/MobileNumberEntry";
import EnterOtp from "../../features/Feature_Login/OtpEntry/OtpEntry";
import {
  useAppDispatch,
  useAppSelector,
} from "../../redux-store/CustomReduxHooks";
import CustomPopup from "../../components/CustomPopup/CustomPopup";
import CommonGifAnimation from "../../components/CustomGifAnimation/CommonGifAnimation";
import { Colors } from "../../styles/constant";
import {
  E_ChannelOptions,
  LoginScreenValues,
  T_AnimationData,
} from "../../globalTypes/GlobalTypes";
import ExclamationMarkGif from "../../assets/gif/Exclamation_Mark.json";
import CsLocalStorageUtils from "../../utils/CsLocalStorageUtils";
import { useNavigate } from "react-router-dom";
import {
  ABCD_SUPERAPP_URL,
  DEVICE_TYPE,
  iOSType,
  REGISTER_BIO_METRIC,
} from "../../utils/constants";
import { useEffect, useState } from "react";
import { updateLoadingState } from "../Feature_Loading/Loading_Slice";
import { Footer } from "../../components/CustomFooter/CustomFooter";
import "./Feature_Login.scss";
import CustomNetworkImage from "../../components/CustomNetworkImage/CustomNetworkImage";
import {
  defaultEmptyFun,
  getMobileOperatingSystem,
  getModuleNameFromPath,
} from "../../utils/helper";
import {
  resetLoginData,
  updateLoginData,
  updateScreenTag,
} from "./Login_Slice";
import { clearCustomerAndLobDetailsArr } from "../../redux-store/reducers/CsAppSlice";
import { useLazyGenerateOtpQuery } from "./Login_Api";
import { clearError, setError } from "../../redux-store/reducers/CsErrorSlice";
import { getCookie } from "../../utils/CSCookieHandler";
import { useBiometric } from "../../hooks/useBiometric";
import _, { isEmpty } from "lodash";
import useDeviceDetection from "../../hooks/useDeviceDetection";
import LoginWithMPIN from "./LoginWithMPIN/LoginWithMPIN";
import SetupMpn from "../Feature_GeneralAppElements/SetupMpn/SetupMpn";
import useWindowSize from "../../hooks/useWindowSize";
import LoginCarousel from "./LoginCarousel/LoginCarousel";
import CustomOnePlatformBox from "../../components/CustomOnePlatformBox/CustomOnePlatformBox";
import dragHandle from "../../assets/icons/Drag-Handle.svg";
import { useSaveUIException } from "../../hooks/useSaveUIException";

const FeatureLogin: React.FC = () => {
  const [loginCarousel, setLoginCarousel] = useState<boolean>(true);
  const loginSlice = useAppSelector((state) => state.LoginSlice);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const secondaryChannelSlice = useAppSelector(
    (state) => state.SecondaryChannelSlice
  );
  const cmsData = useAppSelector((state) => state.CmsSlice.CmsPageVariableData);
  const csErrorData = useAppSelector((state) => state.CsErrorSlice);
  const cmsLogo =
    cmsData.find((i) => i.attributes.cmsType === "ABC Logo")?.attributes.image
      .data?.attributes.url ?? "";
  const { width } = useWindowSize();
  const [generateOtpApi] = useLazyGenerateOtpQuery();
  const { triggerSaveUIException } = useSaveUIException();
  const initiateBiometricScan = useBiometric("verify");
  const deviceType = useDeviceDetection();
  const [isAskForConsentVisible, setIsAskForConsentVisible] = useState(false);
  const isMobile = deviceType === DEVICE_TYPE.MOBILE;

  const onAskConsentValueChange = (newVal: boolean) => {
    setIsAskForConsentVisible(newVal);
  };

  useEffect(() => {
    if (!isEmpty(csErrorData.error)) {
      dispatch(clearError());
    }
  }, []);

  const attemptBiometricLogin = (bioInfo: any) => {
    if (!_.isEmpty(bioInfo) && !_.isEmpty(bioInfo?.biometricToken)) {
      initiateBiometricScan(bioInfo?.biometricToken)
        ?.then((result) => {
          dispatch(updateLoginData({ key: "isUserLoggedIn", value: true }));
          dispatch(
            updateLoginData({ key: "mobilenumber", value: bioInfo?.mobile })
          );
          navigate("/", { replace: true });
        })
        .catch((error) => {
          const currentPath = window?.location?.pathname;
          triggerSaveUIException({
            moduleName: getModuleNameFromPath(currentPath),
            pageName: currentPath || "",
            statusCode: 500,
            uiDisplayMessage: `fileName(Feature_Login.tsx) and functionName(initiateBiometricScan) `,
            errorMessage: {
              stk: error.stack || "No stack available",
              msg: error.message || "Unknown error occurred",
            },
          });
        });
    }
  };

  useEffect(() => {
    if (
      csAppSlice.channel === E_ChannelOptions.SECONDARY_CHANNEL &&
      secondaryChannelSlice.mobileNo
    ) {
      dispatch(updateLoadingState(true));
      generateOtpFun();
    } else {
      dispatch(updateLoadingState(false));
    }
  }, []);

  useEffect(() => {
    /**Reset the master details */
    if (csAppSlice.channel !== E_ChannelOptions.SECONDARY_CHANNEL) {
      dispatch(updateLoadingState(false));
    }
    dispatch(resetLoginData());
    dispatch(clearCustomerAndLobDetailsArr());
  }, []);

  useEffect(() => {
    if (
      (csAppSlice.channel === E_ChannelOptions.CSAPP ||
        csAppSlice.channel === E_ChannelOptions.SECONDARY_CHANNEL) &&
      (deviceType === DEVICE_TYPE.MOBILE ||
        deviceType === DEVICE_TYPE.PWA_MOBILE)
    ) {
      const mobileNo = CsLocalStorageUtils.get("MOBILE");
      const mPinCapturedForMobile = CsLocalStorageUtils.get("MPIN_FOR_MOBILE");
      let bioInfo = null;
      if (
        !isEmpty(mobileNo) &&
        !isEmpty(csAppSlice.NativeDeviceInfo?.deviceName) &&
        !csAppSlice.NativeDeviceInfo?.isFirstInstall
      ) {
        if (csAppSlice.NativeDeviceInfo?.systemName === "Android") {
          bioInfo = csAppSlice.NativeDeviceInfo?.bioInfo;
          dispatch({
            type: REGISTER_BIO_METRIC,
            payload: bioInfo,
          });
        } else {
          bioInfo = JSON.parse(getCookie(REGISTER_BIO_METRIC) as any);
        }
        
        if (
          !isEmpty(bioInfo) &&
          !isEmpty(bioInfo?.mobile) &&
          bioInfo?.mobile == mobileNo
        ) {
          dispatch({
            type: REGISTER_BIO_METRIC,
            payload: bioInfo,
          });
          attemptBiometricLogin(bioInfo);
        }
        /** Mpin Condition */
        if (
          !isEmpty(mPinCapturedForMobile) &&
          mobileNo === mPinCapturedForMobile
        ) {
          console.log("I am here 2");
          dispatch(updateScreenTag(LoginScreenValues.LoginWithMPIN));
          return;
        }
      } else if (
        !isEmpty(mobileNo) &&
        !isEmpty(csAppSlice.NativeDeviceInfo?.deviceName)
      ) {
        console.log("I am here 3");
        if (
          !isEmpty(mPinCapturedForMobile) &&
          mobileNo === mPinCapturedForMobile
        ) {
          console.log("I am here 4");
          dispatch(updateScreenTag(LoginScreenValues.LoginWithMPIN));
          return;
        }
      }
    }
    dispatch(updateScreenTag(LoginScreenValues.enterMobileScreen));
  }, [csAppSlice.NativeDeviceInfo]);

  const generateOtpFun = async () => {
    await generateOtpApi({
      mobileNo: "" + secondaryChannelSlice.mobileNo,
      otp: "",
    }).then((res) => {
      if (res.data?.code === 1) {
        dispatch(
          updateLoginData({
            key: "mobilenumber",
            value: secondaryChannelSlice.mobileNo,
          })
        );
        dispatch(updateScreenTag(LoginScreenValues.enterOtpScreen));
      } else {
        dispatch(
          setError({
            error: res.data,
            message: "API failed",
          })
        );
      }
      dispatch(updateLoadingState(false));
    });
  };

  function callComponentByStage(stage: LoginScreenValues) {
    switch (stage) {
      case "LoginWithMPIN":
        return <LoginWithMPIN />;
      case "enterMobileScreen":
        return (
          <MobileNumberEntry
            onAskConsentValueChange={onAskConsentValueChange}
            headerText="Welcome,"
            headerText2=" lets get you started"
            subheaderText=" Enter details to begin"
          />
        );
      case "enterOtpScreen":
        return <EnterOtp headerText={""} onMaximumAttempt={defaultEmptyFun} />;
      case "enterOtpScreenForgotmPIN":
        return (
          <MobileNumberEntry
            headerText="Forgot mPIN"
            subheaderText=" Enter mobile number linked to ABC"
          />
        );
      case "enterMobileScreenForgotPin":
        return (
          <EnterOtp
            headerText={`OTP Verification`}
            onMaximumAttempt={defaultEmptyFun}
          />
        );
      case "setupMPN":
        return <SetupMpn length={4} />;
      default:
        console.error(`Function ${stage} not found.`);
    }
  }

  const isUserBlocked = CsLocalStorageUtils.get("OTP_BLOCKED_TIME")?.length > 0;
  const login_page_container =
    getMobileOperatingSystem() === "iOS" &&
    !isEmpty(csAppSlice.NativeDeviceInfo?.deviceName)
      ? "login-page-container"
      : "";

  function getClassName(stage: LoginScreenValues) {
    console.log(stage);
    switch (stage) {
      case "LoginWithMPIN":
        return "mainCardlayout";
      case "enterMobileScreen":
        return isAskForConsentVisible
          ? "mainCardForEnterMobileNumberlayout mainCardForEnterMobileNumberlayoutWithConsentOption"
          : "mainCardForEnterMobileNumberlayout";
      case "enterOtpScreen":
        return "mainCardForEnterOTPlayout";
      case "enterOtpScreenForgotmPIN":
        return "mainCardForEnterMobileForgetMpinlayout";
      default:
        return "mainCardForEnterMobileNumberlayout";
    }
  }

  const logoImageStyle = {
    web: { height: "2.75rem", width: "7.125rem" },
    mobile: { height: "2.75rem", width: "7.125rem" },
  };

  return (
    <>
      {width < 900 ? (
        <Box className={login_page_container}>
          <Box className="feature-login">
            <Box className="login-page-common">
              <Box className="header-section">
                <CustomNetworkImage
                  fallBackImage={
                    <img
                      src={ABCLogo}
                      alt="logo"
                      style={logoImageStyle.mobile}
                    />
                  }
                  src={cmsLogo}
                  alt="abc-logo-img"
                  style={logoImageStyle.mobile}
                />
              </Box>
              <CustomOnePlatformBox />
              <Box
                zIndex={3}
                className={`${getClassName(loginSlice.screenTag)} ${
                  getMobileOperatingSystem() === iOSType && isMobile
                    ? "iOS-app-only-style"
                    : ""
                }`}
              >
                {loginSlice.screenTag !== "LoginWithMPIN" && (
                  <Box
                    display="flex"
                    justifyContent="center"
                    marginBottom="1rem"
                  >
                    <img src={dragHandle} className="drag-handler" />
                  </Box>
                )}
                <Box display="flex" justifyContent="center">
                  {callComponentByStage(loginSlice.screenTag)}
                </Box>
              </Box>
            </Box>

            {loginSlice.screenTag === "enterMobileScreen" &&
              isEmpty(csAppSlice.NativeDeviceInfo?.deviceName) && (
                <Box
                  sx={{ backgroundColor: "#363636" }}
                  display="flex"
                  justifyContent="center"
                >
                  <Footer />
                </Box>
              )}
          </Box>
        </Box>
      ) : (
        <Box className="feature-login adaptive-web">
          <Grid container>
            <Grid item xs={6} sx={{ position: "relative", overflow: "auto" }}>
              <Box className="left-box">
                <Box className="header-section">
                  <CustomNetworkImage
                    fallBackImage={
                      <img src={ABCLogo} alt="" style={logoImageStyle.web} />
                    }
                    src={cmsLogo}
                    alt="abc-logo-img"
                    style={logoImageStyle.web}
                  />
                </Box>
                <Box
                  className={
                    loginSlice.screenTag === "LoginWithMPIN"
                      ? "mainCardlayout"
                      : "mainCardForEnterMobileNumberlayout"
                  }
                >
                  <Box display="flex" justifyContent="center">
                    {callComponentByStage(loginSlice.screenTag)}
                  </Box>
                </Box>
              </Box>
              {loginSlice.screenTag === "enterMobileScreen" &&
                isEmpty(csAppSlice.NativeDeviceInfo?.deviceName) && (
                  <Box
                    sx={{
                      backgroundColor: "#363636",
                      position: "absolute",
                      left: 0,
                      right: 0,
                    }}
                    display="flex"
                    justifyContent="center"
                  >
                    <Footer />
                  </Box>
                )}
            </Grid>
            <Grid item xs={6}>
              <Box className="login-page-common right-box">
                {<CustomOnePlatformBox />}
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
      <CustomPopup open={isUserBlocked} handleOpen={defaultEmptyFun}>
        <Box padding="1.5rem 1rem">
          <Box
            display="flex"
            justifyContent="center"
            flexDirection={"column"}
            textAlign={"center"}
            alignItems={"center"}
          >
            <CommonGifAnimation
              animationData={ExclamationMarkGif as T_AnimationData}
            />
            <Typography
              marginTop={"2rem"}
              variant="h3"
              color={Colors.textblack}
            >
              You have reached the maximum attempt of tries
            </Typography>
            <Button
              sx={{ width: "100%", marginTop: "2rem" }}
              type="button"
              variant="contained"
              onClick={() => {
                navigate("" + ABCD_SUPERAPP_URL);
              }}
            >
              Go to ABCD homepage
            </Button>
          </Box>
        </Box>
      </CustomPopup>

      {loginSlice.screenTag === "enterMobileScreen" ? (
        <LoginCarousel
          open={loginCarousel}
          setLoginCarousel={setLoginCarousel}
        />
      ) : null}
    </>
  );
};
export default FeatureLogin;
